import React from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import BoltIcon from "@mui/icons-material/Bolt";
import PaletteIcon from "@mui/icons-material/Palette";
import DescriptionIcon from "@mui/icons-material/Description";
import BugReportIcon from "@mui/icons-material/BugReport";
import img from "./img/cardImg.webp";

const CardContent1 = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#ddeffa",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, md: 10 },
          py: { xs: 4, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Grid container spacing={4} alignItems="center">
          {/* Left Text & List */}
          <Grid item xs={12} md={6}>
            <Typography
              variant={isMdUp ? "h4" : "h5"}
              fontWeight="bold"
              gutterBottom
              sx={{ fontSize: { xs: "2.3rem", md: "2.7rem" } }}
            >
              AI Tools to Supercharge{" "}
              <Box component="span" sx={{ color: "#00C851" }}>
                WhatsApp Chatbots
              </Box>
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 3, fontSize: { xs: "1.3rem", md: "1.16rem" } }}
            >
              Take your chatbot performance and campaign automation to the next
              level with VertexSuite AI suite:
            </Typography>

            <List disablePadding>
              <ListItem>
                <ListItemIcon>
                  <BoltIcon sx={{ fontSize: 28 }} color="action" />
                </ListItemIcon>
                <ListItemText
                  primary="AI Ads Manager"
                  secondary="Automatically optimize Click-to-WhatsApp ads for better lead quality."
                  primaryTypographyProps={{
                    fontSize: "1.125rem",
                    fontWeight: 500,
                  }}
                  secondaryTypographyProps={{ fontSize: "1rem" }}
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <PaletteIcon sx={{ fontSize: 28 }} color="action" />
                </ListItemIcon>
                <ListItemText
                  primary="AI Ad Creative Generator (Beta)"
                  secondary="Instantly create campaign creatives from simple prompts."
                  primaryTypographyProps={{
                    fontSize: "1.125rem",
                    fontWeight: 500,
                  }}
                  secondaryTypographyProps={{ fontSize: "1rem" }}
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <DescriptionIcon sx={{ fontSize: 28 }} color="action" />
                </ListItemIcon>
                <ListItemText
                  primary="AI WhatsApp Template Generator (Beta)"
                  secondary="Write Meta-approved message templates with AI."
                  primaryTypographyProps={{
                    fontSize: "1.125rem",
                    fontWeight: 500,
                  }}
                  secondaryTypographyProps={{ fontSize: "1rem" }}
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <BugReportIcon sx={{ fontSize: 28 }} color="action" />
                </ListItemIcon>
                <ListItemText
                  primary="AI Chatbot Flow Generator (Staging)"
                  secondary="Let AI build your entire chatbot flow based on your goals."
                  primaryTypographyProps={{
                    fontSize: "1.125rem",
                    fontWeight: 500,
                  }}
                  secondaryTypographyProps={{ fontSize: "1rem" }}
                />
              </ListItem>
            </List>
          </Grid>

          {/* Right Image */}
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={img}
              alt="AiSensy AI Suite"
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: 2,
                boxShadow: 3,
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CardContent1;
